import options from "contexts/options.json"
import { useMongoQueries } from "contexts/useMongoQuery";

export const useInternalDoctors = () => {
    const { data, loading, error } = useMongoQueries("user", { internal: true, clinic: { $oid: options.centralClinic.id } });
    if (error) {
        throw new Error(`Failed to fetch useInternalDoctors`);
    }
    const doctors:KV[] = data ?? [];
    return {
        doctors,
        loading,
    }
}
